export default __webpack_public_path__ + "static/media/amanah.9174eabe.png";